import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Subscription() {
  return <section id="subscribe" className="py-24 md:py-32 bg-linen" data-id="element-66">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center" data-id="element-67">
        <motion.div className="w-full max-w-md bg-soft-white rounded-2xl p-8 md:p-12 shadow-xl shadow-stone/20 border border-stone/40" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-68">
          <div className="text-center mb-8" data-id="element-69">
            <span className="text-xs uppercase tracking-[0.2em] text-warm-gray block mb-4" data-id="element-70">
              Subscribe
            </span>
            <div className="flex items-baseline justify-center gap-1" data-id="element-71">
              <span className="font-serif text-5xl text-charcoal" data-id="element-72">$15</span>
              <span className="font-sans text-warm-gray text-sm" data-id="element-73">/month</span>
            </div>
          </div>

          <div className="space-y-6 mb-10" data-id="element-74">
            {['One handwritten letter, monthly', 'Premium cotton paper', 'Shipping included', 'Cancel anytime'].map(feature => <div key={feature} className="flex items-center justify-center text-center border-b border-stone/30 pb-4 last:border-0 last:pb-0" data-id="element-75">
                <span className="font-sans text-charcoal" data-id="element-76">{feature}</span>
              </div>)}
          </div>

          <button className="w-full py-4 bg-charcoal text-cream rounded-full font-medium transition-transform hover:scale-[1.02] duration-300 shadow-lg shadow-charcoal/10 mb-6" data-id="element-77">
            Subscribe
          </button>

          <div className="text-center" data-id="element-78">
            <a href="#gift" className="text-sm text-warm-gray hover:text-charcoal transition-colors" data-id="element-79">
              Or give as a gift &rarr;
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}